/**
 * Weather line for a picked day other than today.
 *
 * Today keeps the live time-slot line; every other day reads the stored
 * forecast of that date. A forecast further than three days out is marked as
 * an outlook, and a day whose parts differ from its overall condition names
 * the part instead ("am Nachmittag Regen").
 */
const CONDITIONS = {
  de: { sunny: 'sonnig', cloudy: 'bewölkt', rainy: 'Regen', snowy: 'Schnee' },
  en: { sunny: 'sunny', cloudy: 'cloudy', rainy: 'rain', snowy: 'snow' },
};

const SLOTS = [
  { key: 'morning', de: 'am Morgen', en: 'in the morning' },
  { key: 'midday', de: 'am Mittag', en: 'at midday' },
  { key: 'afternoon', de: 'am Nachmittag', en: 'in the afternoon' },
  { key: 'evening', de: 'am Abend', en: 'in the evening' },
];

/** Localized condition word ("sonnig" / "sunny") for a weather condition key. */
export function conditionLabel(condition, language = 'de') {
  const conditions = CONDITIONS[language] || CONDITIONS.de;
  return conditions[condition] || '';
}

/** Whole days between today and the picked day. */
export function daysAhead(option, now = new Date()) {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((option.date - today) / 86400000);
}

/** → { condition, text } for the picked day, or null when there is no forecast. */
export function buildDayWeatherLine(record, option, language = 'de', now = new Date()) {
  if (!record) return null;

  const conditions = CONDITIONS[language] || CONDITIONS.de;
  const temperature = record.temperature_max ?? record.temperature_min;

  // Name the part of the day that deviates from the overall condition.
  const deviating = SLOTS.find(
    (slot) => record.slots?.[slot.key]?.condition && record.slots[slot.key].condition !== record.condition
  );
  const descriptor = deviating
    ? `${deviating[language === 'en' ? 'en' : 'de']} ${conditions[record.slots[deviating.key].condition] || ''}`.trim()
    : conditions[record.condition] || '';

  const outlook = daysAhead(option, now) > 3 ? (language === 'en' ? 'likely ' : 'voraussichtlich ') : '';
  const temperaturePart = temperature != null ? `${outlook}${temperature}°` : '';
  const head = [option.label, temperaturePart].filter(Boolean).join(' ');

  return {
    condition: record.condition || null,
    text: descriptor ? `${head}, ${descriptor}` : head,
  };
}